<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav" :class="mainStatus === 'online' && 'active'" @click.stop="handleClick('online')">{{$t('apiDoc.在线文档')}}</span>
      <!-- <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">{{$t('apiDoc.测试工具')}}</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <!-- <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div> -->
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

// import apiTestDoc from "../components/apiTestDoc";

// import { OPEN_API_TEST, OPEN_API_PRO } from '@/constants/index'
// const apiUrlTest = 'collectionRefund/subscribe';
export default {
  components: { onlineDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      // apiBaseUrl: `${this.$t('onlineDoc.地址')}`,
      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.subscribeOtherDesc')}`,
        //接口地址
        isNoTest: `${this.$t('onlineDoc.地址')}`,
        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: `${this.$t('onlineDoc.Headers')}`,
            value: [
              { name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
              { name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.签名字符串')}`, },
              { name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.时间戳，毫秒')}`, },
              { name: "digestType", type: "Number", require: "N", normal: "", describe: `${this.$t('onlineDoc.签名类型')}`, },
            ]
          },
          {
            title: `${this.$t('onlineDoc.请求参数')}`,
            value: [
              { name: "bizContent", type: "String", require: "Y", normal: `${this.$t('onlineDoc.业务参数')}`, describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`, },
            ]
          },
          {
            title: `${this.$t('onlineDoc.业务参数')}`,
            value: [
              { name: "rebateTime", type: "String", require: "Y", normal: "2022-12-06 06:25:30", describe: `${this.$t('onlineDoc.登记时间')}` },
              { name: "billSerialNum", type: "String", require: "Y", normal: "2022120612345", describe: `${this.$t('onlineDoc.订单流水号')}` },
              { name: "customerCode", type: "String", require: "Y", normal: "J0086024071", describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}` },
              { name: "rebateSchedule", type: "Integer", require: "Y", normal: "2", describe: `${this.$t('onlineDoc.返款进度')}` },
              { name: "payCustomerCollectionAmount", type: "Double", require: "Y", normal: "900", describe: `${this.$t('onlineDoc.应付客户货款⾦额')}` },
              { name: "waybillNumSum", type: "Integer", require: "Y", normal: "2", describe: `${this.$t('onlineDoc.总运单票数')}` },
              { name: "wayNos", type: "Array", require: "Y", normal: "['UTE300000530056','UTE300000282217']", describe: `${this.$t('onlineDoc.运单列表信息')}` }
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [

          //   响应参数
          {
            title: `${this.$t('onlineDoc.响应参数')}`,
            value: [
              { name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回码，见附录')}` },
              { name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.描述')}` }
            ]
          }
        ],
        //请求示例
        requestCode: `Header：
apiAccount=292508153084379141
digest=U40e5sumorgd3YgZzU61Mw==
timestamp=1565238848921

Body：{"bizContent": "{
 "rebateTime": "2022-12-06 06:25:30",
 "billSerialNum": "2022120612345",
 "customerCode": "J0086024316",
 "rebateSchedule": 1,
 "payCustomerCollectionAmount": 20,
 "waybillNumSum": 2,
 "wayNos": ["UTE300000530056", "UTE300000282217"]
}
"}`,
        //返回示例
        responseCode: JSON.parse(
          `{"code":"1","msg":"success"}`
        ),


        //错误代码提示
        errcodeJson: []
      }
    };
  },
  created() { },
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>